import { render, staticRenderFns } from "./TabsDetailsFicheProjet.vue?vue&type=template&id=321d66bf&"
import script from "./TabsDetailsFicheProjet.vue?vue&type=script&lang=js&"
export * from "./TabsDetailsFicheProjet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports